import {
  EditingInputRow,
  FlexSummaryInset,
  LogoSpinner,
  MarginlessBody2Secondary,
  ReviewDataRow,
} from 'modules/frequencyManagement/components/optimize/Optimize.styles';
import { OptimizeInputFields } from 'modules/frequencyManagement/components/optimize/OptimizeInputFields';
import { OptimizePendingEditTestId } from 'modules/frequencyManagement/components/optimize/Optimize.constants';
import { ConnectedFormMultiField } from 'modules/frequencyManagement/components/connectedFormMultiField/ConnectedFormMultiField';
import { OptimizeFormLabel } from 'modules/frequencyManagement/components/optimize/OptimizeFormLabel';
import {
  SchemaFormKeys,
  OPTIMIZE_MIN_ALLOWED,
  OPTIMIZE_MAX_ALLOWED,
} from 'modules/frequencyManagement/contexts/FormProvider';
import { OptimizeBaseProps } from 'modules/frequencyManagement/components/optimize/Optimize.types';

export const OptimizePendingEdit = ({ rootName }: OptimizeBaseProps) => {
  const minName = rootName ? `${rootName}.${OPTIMIZE_MIN_ALLOWED}` : OPTIMIZE_MIN_ALLOWED;
  const maxName = rootName ? `${rootName}.${OPTIMIZE_MAX_ALLOWED}` : OPTIMIZE_MAX_ALLOWED;
  return (
    <FlexSummaryInset data-test={OptimizePendingEditTestId}>
      <ConnectedFormMultiField
        hasSavedData
        names={[minName, maxName] as SchemaFormKeys[]}
        labelText={<OptimizeFormLabel />}
      >
        <EditingInputRow data-border={true}>
          <OptimizeInputFields rootName={rootName} />
        </EditingInputRow>
      </ConnectedFormMultiField>
      <ReviewDataRow>
        <LogoSpinner size={16} />
        <MarginlessBody2Secondary>
          Your audience distribution by optimal cap is being calculated... You&apos;ll see your
          results here soon
        </MarginlessBody2Secondary>
      </ReviewDataRow>
    </FlexSummaryInset>
  );
};
